import { render, staticRenderFns } from "./TutoInfo.vue?vue&type=template&id=2ccf752f"
import script from "./TutoInfo.vue?vue&type=script&lang=js"
export * from "./TutoInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports